import { render, staticRenderFns } from "./ModalBonus.vue?vue&type=template&id=82b37d00&scoped=true&"
import script from "./ModalBonus.vue?vue&type=script&lang=ts&"
export * from "./ModalBonus.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBonus.vue?vue&type=style&index=0&id=82b37d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b37d00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PhoneNumberEntry: require('/usr/www/nuxt/components/PhoneNumberEntry.vue').default,WriteOffBonuses: require('/usr/www/nuxt/components/WriteOffBonuses.vue').default,BonusInfo: require('/usr/www/nuxt/components/BonusInfo.vue').default,EnteringCode: require('/usr/www/nuxt/components/EnteringCode.vue').default})
